

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userLogout } from "../../container/Header/service";
import { setUserLogin } from "../../container/Login/slice/userLoginSlice";
import { clearUserDetails } from "../../container/Login/slice/userSlice";

export const Session = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inactivityTimeout = 1000 * 60 * 30; // 30 minutes
  let timeoutId;
  const { token } = useSelector((state) => state.userState);

  const logout = async () => {
    const params = {
      token: token,
    };
    try {
      const resp = await userLogout(params);
      if (resp.status === 200) {
        dispatch(setUserLogin({ userName: null }));
        dispatch(clearUserDetails());
        navigate("/");
        window.location.reload(false);
        localStorage.clear();
      }else {
        console.error("Logout failed with status:", resp.status);
        // Handle other status codes if needed
      }
    } catch (error) {
      console.log(error);
    }

  }

  const resetLogoutTimer = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(logout, inactivityTimeout);
  };

  useEffect(() => {

      resetLogoutTimer();

      const handleActivity = () => {
        resetLogoutTimer();
      };
  
      document.addEventListener("mousemove", handleActivity);
      document.addEventListener("click", handleActivity);
      document.addEventListener("keydown", handleActivity);
      document.addEventListener("touchstart", handleActivity);
  
      return () => {
        document.removeEventListener("mousemove", handleActivity);
        document.removeEventListener("click", handleActivity);
        document.removeEventListener("keydown", handleActivity);
        document.removeEventListener("touchstart", handleActivity);
        clearTimeout(timeoutId);
      };
    
   
  }, []);

  return <div>{/* Render your data or other components here */}</div>;
}